import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { shortenDescription } from '../../../common/description';

const formatSignedPoint = (value) => {
    const numericValue = Number(value || 0);
    const sign = numericValue > 0 ? '+' : '';
    return `${sign}${numericValue.toLocaleString()}`;
};

function RoomUser(props) {
    const user = props.user;
    const index = props.index;

    const getTableRowStyle = (index) => {
        //現在1位表記
        if (index == 0) {
            return {backgroundColor: "Gold",}
        //2
        } else if (index == 1) {
            return {backgroundColor: "silver",}
        //3
        } else if (index == 2) {
            return {backgroundColor: "rgb(196 112 34)",}
        //通常順位偶数
        } else if(index % 2 == 0) {
            return {backgroundColor: "rgb(196 112 34)",}
        //通常順位奇数
        } else {
            return {backgroundColor: "rgb(196 112 34)",}
        }
    };
      
      const getTableCellStyle = (index) => {
        if (index == 0) {
            return {
                padding: '10px 12px',
                fontSize: '14px',
                color: '#333',
                textAlign: 'center',
                border: '1px solid rgba(224, 224, 224, 1)',

            }
        } else {
            return {
                padding: '10px 12px',
                fontSize: '14px',
                color: '#333',
                textAlign: 'center',
                border: '1px solid rgba(224, 224, 224, 1)',

            }
        }
    };

    return (
        <TableRow
            onClick={()=>props.onClick()}
            style={getTableRowStyle(index)}>
            <TableCell style={{ ...getTableCellStyle(), width: '60px' }}>
            {user.rank === 999 ? '-' : user.rank}
            </TableCell>
            <TableCell style={{ ...getTableCellStyle(), minWidth: '160px', maxWidth: '240px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user.name}</TableCell>
            <TableCell style={{ ...getTableCellStyle(), width: '90px' }}>{formatSignedPoint(user.balance)}</TableCell>
            <TableCell style={{ ...getTableCellStyle(), width: '90px' }}>{user.winRate}</TableCell>
            <TableCell 
                style={{
                    ...getTableCellStyle(), 
                    minWidth: '220px',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    textAlign: 'left'
                }}
            >
                {shortenDescription(user.description, 20)}
            </TableCell>
        </TableRow>
    )
}
export default RoomUser;
